import { Tooltip } from "antd";
import { formatPhoneNumber } from "../../../../utils/appUtils";
import { lang_en_US as translation } from "../../../../config";
import dayjs from "dayjs";

export const CUSTOMER_COLUMS_HEADER = ({ actionRender, userStatus }) => [
    {
        title: "SNo",
        align: "center",
        width: 60,
        render: (_, detail, index) => <>{index + 1}</>
    },
    {
        title: "Date",
        width: 100,
        align: "center",
        render: (detail) => <>{detail?.date ? dayjs(detail?.date).format("DD-MM-YYYY") : "Nil"}</>
    },
    {
        title: "Customer Name",
        align: "center",
        width: 200,
        render: (_, detail) => {
            const first = detail?.firstName || "";
            const middle = detail?.middleName || "";
            const last = detail?.lastName || "";
            const fullName = `${first} ${middle} ${last}`.trim();
            const isLastLong = last?.length > 10;
            const shortName = isLastLong
                ? `${first} ${middle} ${last?.slice(0, 3)}...`
                : fullName;
            return (
                <>
                    {isLastLong ? (
                        <Tooltip title={fullName}>
                            <p style={{ padding: 0, margin: 0 }}>{shortName}</p>
                        </Tooltip>
                    ) : (
                        <p style={{ padding: 0, margin: 0 }}>{shortName}</p>
                    )}
                </>
            );
        },
    },
    {
        title: "Customer ID",
        width: 120,
        render: (detail) => {
            return <>{detail?.customerNo || "Nil"}</>
        }
    },
    {
        title: "Contact Info",
        width: 160,
        align: "center",
        render: (detail) => {
            return <><p style={{ padding: "5px", margin: 0 }}>{detail?.mobileNumber ? formatPhoneNumber(detail?.mobileNumber) : "Nil"}</p></>
        },
    },
    {
        title: "Email",
        width: 180,
        render: (detail) => {
            return <>{detail?.email || "Nil"}</>
        }
    },
    {
        title: "Total Cons.",
        width: 120,
        align: "center",
        dataIndex: "totalConsultation"
    },
    {
        title: "Upcoming Cons.",
        width: 120,
        align: "center",
        dataIndex: "upcomingConsultation"
    },
    {
        title: "Cancelled Cons.",
        width: 120,
        align: "center",
        dataIndex: "totalCancelConsultation"
    },
    {
        title: "Recorded Complaint",
        width: 150,
        align: "center",
        dataIndex: "thisMonthRecordedComplaint",
        render: (_, detail) => detail?.customerComplaintCount?.thisMonthRecordComplaintCount ?? detail?.CustomerComplaintCount?.thisMonthRecordComplaintCount ?? "0"
    },
    {
        title: "Non recorded complaint",
        width: 150,
        align: "center",
        dataIndex: "thisMonthNonRecordedComplaint",
        render: (_, detail) => detail?.customerComplaintCount?.thisMonthNonRecordComplaintCount ?? detail?.CustomerComplaintCount?.thisMonthNonRecordComplaintCount ?? "0"
    },
    {
        title: "Warning Count",
        width: 120,
        align: "center",
        dataIndex: "totalWarningCount",
        render: (totalWarningCount) => totalWarningCount ?? "Nil"
    },
    ...(userStatus === "HOLD" ? [
        {
            title: "Block Days",
            width: 120,
            align: "center",
            render: (detail) => {
                const lastBlock = detail?.blockInfo?.[detail?.blockInfo?.length - 1];
                return <>{lastBlock?.blockDays || "Nil"}</>
            }
        },
        {
            title: "Block Date",
            width: 140,
            align: "center",
            render: (detail) => {
                const lastBlock = detail?.blockInfo?.[detail?.blockInfo?.length - 1];
                return <>{lastBlock?.blockDate ? dayjs(lastBlock?.blockDate).format("DD-MM-YYYY") : "Nil"}</>
            }
        },
        {
            title: "Reason for Block",
            width: 220,
            render: (detail) => {
                const lastBlock = detail?.blockInfo?.[detail?.blockInfo?.length - 1];
                const reason = lastBlock?.reason || "Nil";
                if (reason?.length > 20) {
                    return <Tooltip title={reason}>
                        <span>{reason?.slice(0, 20)}...</span>
                    </Tooltip>
                }
                return <><span>{reason}</span>
                </>
            }
        }
    ] : []),
    {
        title: "Action",
        width: 80,
        fixed: "right",
        render: (detail) => actionRender(detail)
    }
];

export const actionDropdownMenu = [
    { key: "view", label: "View" },
    { key: "hold", label: "Hold" },
    { key: "complaints", label: "Complaints" },
    { key: "consultation", label: "Consultation" }
];

export const consultationTabData = [
    { label: "Completed Consultation", content: "COMPLETED", key: "1" },
    { label: "Cancelled Consultation", content: "CANCELLED", key: "2" },
    { label: "Upcoming Consultation", content: "PENDING", key: "3" },
    { label: "Auto Cancelled Cons.", content: "AUTO_CANCELLED", key: "4" }
];

export const completeConsultationDropdown = [
    { key: "view", label: "View" },
    { key: "viewComplaint", label: "View Complaints" },
    { key: "viewLawyerRasiedComplaints", label: "View Advocate Rasied Complaint" },
    { key: "viewCustiomerRasiedComplaint", label: "View Customer Rasied Complaint" },
];

export const pendingConsultationDropdown = [
    { key: "view", label: "View" },
];

export const complaintAgainstDropdown = [
    { key: "view", label: "View" },
];

export const complaintesCustomerTabData = [
    { label: "Complaints Against Customer", content: translation?.customer?.complaintsAgaintCustomerTitle, key: "1" },
    { label: "Complaints Raised Customer", content: translation?.customer?.complaintsRaisedCustomerTitle, key: "2" },
    { label: "Support", content: "support", key: "3" }
];